/* eslint-disable jsx-a11y/control-has-associated-label */
import React from 'react';
import LoaderStore from 'lib/stores/loaderStore';

const Progress = () => {
  const { progress, status } = LoaderStore.useState(state => state);

  if (!progress || !status) return <></>;

  return (
    <div className="progress-wrapper mt-3">
      <div className="progress-info info-xl">
        <span className="h4 progress-tooltip bg-primary">{status}</span>
        <div className="progress-percentage">
          <span>
            {progress}
            %
          </span>
        </div>
      </div>
      <div className="progress progress-xl">
        <div
          className="progress-bar progress-bar-animated progress-bar-striped"
          role="progressbar"
          style={{ width: `${progress}%` }}
          aria-valuenow={progress}
          aria-valuemin="0"
          aria-valuemax="100"
        />
      </div>
    </div>
  );
};

export default Progress;
